// extracted by mini-css-extract-plugin
module.exports = {"icon-wrapper":"_9400a595a7--icon-wrapper--dHgKK"};